import React, { useState, useEffect } from "react";
import {
  FaComments,
  FaUserCheck,
  FaEnvelopeOpenText,
  FaCheckCircle,
  FaArrowRight,
} from "react-icons/fa";
import api from "../../api/axios";
import "./WhatsAppChat.css";

const WhatsAppDashboard = ({ onOpenChatWithId }) => {
  const [stats, setStats] = useState({
    total_conversations: 0,
    active_conversations: 0,
    unclaimed_chats: 0,
    account_status: {
      whatsapp_no: "Rekonic Cloud API",
      status: "CONNECTED",
      tier: "TIER_1K (1,000 Messages / Day)",
      quality_rating: "GREEN",
    },
    floor_view: [],
  });

  const fetchDashboardStats = async () => {
    try {
      const res = await api.get("/whatsapp/dashboard-stats");
      if (res.data) {
        setStats((prev) => ({ ...prev, ...res.data }));
      }
    } catch (err) {
      console.log("Error fetching dashboard stats:", err);
    }
  };

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  return (
    <div className="rekonic-dash-wrapper">
      {/* ── KPI Stat Cards ────────────────────────────────────────── */}
      <div className="rekonic-dash-kpi-grid">
        <div className="rekonic-dash-card">
          <div>
            <div className="rekonic-dash-card-num">{stats.total_conversations}</div>
            <div className="rekonic-dash-card-lbl">Total Conversations</div>
          </div>
          <FaComments className="rekonic-dash-card-icon" />
        </div>

        <div className="rekonic-dash-card">
          <div>
            <div className="rekonic-dash-card-num">{stats.active_conversations}</div>
            <div className="rekonic-dash-card-lbl">Active Conversations</div>
          </div>
          <FaUserCheck className="rekonic-dash-card-icon" />
        </div>

        <div className="rekonic-dash-card">
          <div>
            <div className="rekonic-dash-card-num">{stats.unclaimed_chats}</div>
            <div className="rekonic-dash-card-lbl">Unread Inquiries</div>
          </div>
          <FaEnvelopeOpenText className="rekonic-dash-card-icon" />
        </div>

        <div className="rekonic-dash-card">
          <div>
            <div className="rekonic-dash-card-num" style={{ color: "#16a34a", fontSize: "20px" }}>
              {stats.account_status?.status || "CONNECTED"}
            </div>
            <div className="rekonic-dash-card-lbl">{stats.account_status?.tier || "Meta API Tier 1K"}</div>
          </div>
          <FaCheckCircle className="rekonic-dash-card-icon" style={{ color: "#16a34a" }} />
        </div>
      </div>

      {/* ── Active Conversations Table ───────────────────────────── */}
      <div className="rekonic-dash-table-wrap">
        <h3 className="rekonic-dash-table-title">Recent WhatsApp Activity</h3>
        <table className="rekonic-dash-table">
          <thead>
            <tr>
              <th>Customer / Contact</th>
              <th>Phone Number</th>
              <th>CRM Status</th>
              <th>Last Activity</th>
              <th>Handling Staff</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {stats.floor_view && stats.floor_view.length > 0 ? (
              stats.floor_view.map((row) => (
                <tr key={row.id}>
                  <td style={{ fontWeight: 600 }}>{row.customer_name}</td>
                  <td>{row.mobile_no}</td>
                  <td>
                    {row.is_crm_customer ? (
                      <span className="rekonic-crm-badge">CRM: {row.customer_code || "Linked"}</span>
                    ) : (
                      <span className="rekonic-lead-badge">Lead</span>
                    )}
                  </td>
                  <td>{row.time_received}</td>
                  <td>{row.serving_by || "Rekonic Support"}</td>
                  <td>
                    <button
                      className="rekonic-btn-shortcut"
                      onClick={() => onOpenChatWithId && onOpenChatWithId(row.id)}
                    >
                      Open Chat <FaArrowRight style={{ fontSize: "10px" }} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} style={{ textAlign: "center", color: "#64748b", padding: "24px" }}>
                  No recent WhatsApp conversations recorded yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WhatsAppDashboard;
